<ul class="opportunities qa-alerts-opportunities">
    <li class="opportunity" *ngFor="let alert of values">
        <alert *ngIf="!showRelavantInfo" [alertTypeId]="alert.type"></alert>
        <span *ngIf="showRelavantInfo" [innerHtml]="alert.message"></span>
    </li>
</ul>
